import './navbar.css';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { isLoggedIn, logout } = useAuth();
    const navigate = useNavigate();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const handleLogout = async () => {
        await logout();
        closeMenu();
        navigate('/');
    };

    return (
        <nav className="navbar">
            <Link to="/" className="navbar-brand" onClick={closeMenu}>
                Čtenářáky
            </Link>

            <button className="navbar-toggle" onClick={toggleMenu} aria-label="Toggle navigation">
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
            </button>

            <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
                <Link to="/" className="navbar-link" onClick={closeMenu}>Domů</Link>
                <Link to="/knihy" className="navbar-link" onClick={closeMenu}>Knihy</Link>
                <Link to="/autori" className="navbar-link" onClick={closeMenu}>Autoři</Link>
                <Link to="/kvizy" className="navbar-link" onClick={closeMenu}>Kvízy</Link>
                <Link to="/seznam-cetby" className="navbar-link" onClick={closeMenu}>Seznam četby</Link>
                {isLoggedIn ? (
                    <>
                        <Link to="/editor-kvizu" className="navbar-link" onClick={closeMenu}>Editor kvízů</Link>
                        <Link to="/admin" className="navbar-link" onClick={closeMenu}>Admin</Link>
                        <button className="navbar-link navbar-auth-btn navbar-logout" onClick={handleLogout}>Odhlásit</button>
                    </>
                ) : (
                    <Link to="/login" className="navbar-link navbar-auth-btn" onClick={closeMenu}>Přihlásit</Link>
                )}
            </div>
        </nav>
    )
}

export default Navbar;
